

export default {
  state:{
    preguntas:{},
  },

  mutations: {

    setAlergologicaPreguntas(state, data){
      state.preguntas = data;
    },

  },
}